module.exports = __webpack_public_path__ + "img/sel_Shanghai.16f14880.png";